/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useRef, useState } from 'react'
import {
  getMergedClassNames,
  getUniqueKey,
  isMobile
} from '../../utils/HTMLutils'
import { scrollSmooth } from '../../utils/ScrollUtils'
import useDraggableContainer from '../useDraggableContainer/useDraggableContainer'
import './useCarouselBehaviour.scss'
const rootClassName = 'carousel-behaviour'

interface CarouselBehaviourProps {
  atual: number
  newAtual?: number
  setAtual: (newAtual: number) => void
  slides: any[]
  draggable?: boolean
}

function useCarouselBehaviour(
  props: CarouselBehaviourProps
): [React.ReactElement, (newAtual: number, onScroll: boolean) => void] {
  const [id] = useState<any>(getUniqueKey())
  useDraggableContainer(
    `#${id} .${rootClassName}-content`,
    props.slides!?.length
  )

  const handleChange = (newAtual: number, onScroll = false) => {
    if (!onScroll) {
      const el = document.querySelector(
        `#${id} .${rootClassName}-content`
      ) as HTMLElement
      const width = el.scrollWidth / (props.slides?.length || 1)
      scrollSmooth({
        top: 0,
        left: width * newAtual,
        behavior: 'smooth',
        element: el,
        duration: 500
      })
    } else {
      props.setAtual(newAtual)
    }
  }

  const atualRef = useRef(props.atual)
  atualRef.current = props.atual

  useLayoutEffect(() => {
    const onRes = () => {
      handleChange(atualRef.current, false)
    }
    if (!isMobile()) {
      window.addEventListener('resize', onRes)
    }
    return () => {
      if (!isMobile()) {
        window.removeEventListener('resize', onRes)
      }
    }
  }, [])

  useLayoutEffect(() => {
    if (props.newAtual !== undefined && props.newAtual !== props.atual) {
      handleChange(props.newAtual, false)
    }
  }, [props.newAtual])

  return [
    <div className={rootClassName} id={id}>
      <div
        className={getMergedClassNames([
          `${rootClassName}-content`,
          props.draggable ? 'draggable' : ''
        ])}
        onScroll={() => {
          const el = document.querySelector(
            `#${id} .${rootClassName}-content`
          ) as HTMLElement
          const width = el.scrollWidth / (props.slides?.length || 1)
          const newAtual = Math.round(el.scrollLeft / width)
          handleChange(newAtual, true)
        }}
      >
        {props.slides!?.map((slide: any, index: number) => {
          return (
            <div className={`${rootClassName}-slide`} key={index}>
              {slide}
            </div>
          )
        })}
      </div>
    </div>,
    handleChange
  ]
}

export default useCarouselBehaviour
